import { addElementsToLayout } from "src/app/generator-data/functions/addElementsToLayout";
import { addHeaderToLayout } from "./addHeaderToLayout";

export const addAudienceDataToLayout = (
  gridElements,
  newLayout,
  format,
  campaigns,
  dataAggregation,
) => {
  const aggregation = dataAggregation.campaignAudienceData;

  Object.keys(campaigns).forEach((key) => {
    const campaign = campaigns[key];

    const {
      project: { title },
    } = campaign;

    if (!aggregation && key !== "aggregated") {
      addHeaderToLayout(`audience-data-${title}`, newLayout, format, 3);
    }

    const gridElementsToAdd = gridElements.filter(
      (item) => item.gridBoxType === "audience-data" && item.campaignId === key,
    );
    addElementsToLayout(gridElementsToAdd, newLayout, format, []);
  });
};
